/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useState, useEffect, CSSProperties } from "react";
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import FileSaver from 'file-saver';
import theme from "src/theme/light";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage } from "@fortawesome/free-solid-svg-icons";
import { LinearProgressBar } from "src/framework/components/commons/LinearProgressBar";
import { Grid } from "@mui/material";

export interface InputUploadImageProps {
    id: number;
    url: string;
    downloadName: string;
    onHandleUpload: (id: number, file: File) => void;
    onHandleRemove: () => void;
    style?: CSSProperties;
    progress?: number,
    disableSelecionar?: boolean,
    disableRemover?: boolean,
}

const HEIGHT = "64px"

const InputUploadImage: FC<InputUploadImageProps> = ({
    id,
    url,
    progress,
    downloadName,
    onHandleUpload,
    onHandleRemove,
    style = {},
    children,
    disableSelecionar = false,
    disableRemover = false,
}) => {
    // States
    const [selectedImage, setSelectedImage] = useState<any>(null);
    const [imageUrl, setImageUrl] = useState<any>(null);
    const [newUpload, setNewUpload] = useState<any>(false);

    // Effects
    useEffect(() => {
        if (selectedImage) {
            setImageUrl(URL.createObjectURL(selectedImage));

            if (onHandleUpload) {
                onHandleUpload(id, selectedImage);
            }
        }
    }, [selectedImage]);


    useEffect(() => {
        if (url !== "") {
            setImageUrl(url);
        } else {
            setImageUrl(null);
        }
        setNewUpload(url === "")
    }, [url]);

    // Methods
    const download = (): void => {
        if (url) {

            const name: string[] = imageUrl.split(".");
            const extension: string | undefined = name.pop()?.replace(/\?r=\d{1,}/, "");

            if (extension) {
                FileSaver.saveAs(imageUrl, `${downloadName}.${extension}`)
            }
        }
    };


    return (
        <>
            <Box style={{ ...style, background: theme.palette.background.default, height: "130px" }} pb={1} pt={1} >
                <Box style={{ height: "64px" }} mb={1} justifyItems={"center"} alignItems={"center"}>
                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <input
                            accept="image/*"
                            type="file"
                            id={"select-image-" + id}
                            style={{ display: 'none' }}
                            onChange={(e) => {
                                if (e.target.files !== null) {
                                    setSelectedImage(e.target?.files[0])
                                }
                            }}
                        />
                        {imageUrl === null && (
                            <Box mt={2}><FontAwesomeIcon icon={faImage} size="3x" fixedWidth style={{ margin: "0 auto", color: "#717171" }} height={HEIGHT} /></Box>
                        )}
                        {imageUrl && (
                            <>

                                {imageUrl !== "" ? (<img src={imageUrl} height={HEIGHT} alt="Imagem do upload" />) : ""}
                                {/* {!newUpload && (
                                    <>
                                        <Button variant="text" color="default" component="span" size="small"
                                            onClick={() => {
                                                setImageUrl(null);
                                                setNewUpload(true);
                                                onHandleRemove()
                                            }}
                                        >
                                            Remover
                                        </Button>
                                        <Button variant="text" color="secondary" component="span" size="small"
                                            onClick={() => {
                                                download();
                                            }}
                                        >
                                            Download
                                        </Button>
                                    </>
                                )} */}
                            </>
                        )}
                    </Grid>
                </Box>
                <Box style={{ height: "44.5px" }} >
                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="flex-end"
                    >
                        <Box m={1} style={{ width: "100%" }}>
                            {progress && progress <= 99.9 && (<LinearProgressBar progress={Number(progress)} />)}
                            {!newUpload && !disableRemover && (
                                <>
                                    <Button
                                        variant="text"
                                        component="span"
                                        size="small"
                                        onClick={() => {
                                            setImageUrl(null);
                                            setNewUpload(true);
                                            onHandleRemove()
                                        }}>
                                        Remover
                                    </Button>
                                    <Button variant="text" color="secondary" component="span" size="small"
                                        onClick={() => {
                                            download();
                                        }}
                                    >
                                        Download
                                    </Button>
                                </>
                            )}
                            {newUpload && (progress === undefined || progress === 100) && !disableSelecionar && (
                                <>
                                    <label htmlFor={"select-image-" + id}>
                                        <Button variant="text" color="secondary" component="span" disabled={id <= 0} size="small">
                                            Selecionar
                                        </Button>
                                    </label>
                                </>
                            )}
                        </Box>
                    </Grid>
                </Box>
            </Box>
        </>
    );
}


export { InputUploadImage }